export default "__VITE_ASSET__36639ffb__"